import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-arrow-thin-up",
  "use": "icon-si-glyph-arrow-thin-up-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-arrow-thin-up\" id=\"icon-si-glyph-arrow-thin-up\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1160</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M9.002,0.02 L15.695,6.325 C16.154,6.784 15.992,7.485 15.789,7.684 C15.387,8.086 14.791,8.026 14.387,7.623 L9.949,3.728 L9.947,15.042 C9.947,15.554 9.521,15.968 8.996,15.97 C8.471,15.97 8.045,15.554 8.045,15.042 L8.033,3.831 L3.762,7.685 C3.358,8.087 2.703,8.087 2.301,7.685 C1.897,7.285 1.998,6.736 2.403,6.333 L9.002,0.02 L9.002,0.02 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-arrow-thin-up.svg
// module id = QQxA
// module chunks = 62